import React from "react";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
import { ReactComponent as CardEditIcon } from "../../../../myfin_v2/assets/icons/editCard.svg";
import { ReactComponent as CreateNewScenario } from "../../../../myfin_v2/assets/icons/createNewScenario.svg";
// import { ReactComponent as CloseSideModel } from "../../../../myfin_v2/assets/icons/closeSideModel.svg";
// import { ReactComponent as QuestionMark } from "../../../../myfin_v2/assets/icons/questionECL.svg";
// import { ReactComponent as ActiveRadioBtn }  from '../../../../myfin_v2/assets/icons/activeRadioBtn.svg'
// import { ReactComponent as InactiveRadioBtn }  from '../../../../myfin_v2/assets/icons/inactiveRadioBtn.svg'
import demoUserImg from "../../../../assets/Image/CreatedUserImg.jpg";

import CompanyEditSideMenu from "../CompanyEditSideMenu";
import Breadcrumb from "../../../components/Breadcrumb";

// import sidemenucss from "../../../css/sidemenu.module.css"
import AcntPolcyCss from "../../../css/accountingPolicy.module.css";
import commoncss from "../../../css/common.module.css";

// import HeaderWhenSecondSideBarActive from "../../../elements/HeaderWhenSecondSideBarActive"
// import Select from 'react-select';

import { getAllReceivableECLScenario } from "../../../../Bookclosure/Services/ApiHandler";

const ReceivablesPolicy = () => {
  const { companyId } = useParams();
  const [companyID, setCompanyID] = useState(companyId); // company ID
  const [createOrUpdate, setCreateOrUpdate] = useState("C"); // state for create or update
  const [companyName, setcompanyName] = useState(""); // company name

  // EIR Input
  const [EirScenarioName, setEirScenarioName] = useState();
  const [EirCalculateType, setEirCalculateType] = useState("straightLine");
  const [EirCompute, setEirCompute] = useState("grossOfECL");

  // IRAC Input
  // const [Irac, setIrac] = useState();

  const breadcrumbItems = [
    {
      label: "My companies",
      link: `/myfinV2/my-companies`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: companyName,
      link: `/myfinV2/company-details/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Accounting policy",
      link: `/myfinV2/accounting-policy/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Receivables",
      link: `/myfinV2/receivables-policy/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
  ];

  const [activeTab, setActiveTab] = useState("ECL"); // tabs state

  const [createTab, setCreateTab] = useState("I"); // A active show tab I inactive hide tab

  // const [sideTabType, setsideTabType] = useState(); // ECL or EIR or IRAC

  const routerHistory = useHistory();

  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  return (
    <div className={`${AcntPolcyCss.subContainer}`}>
      <CompanyEditSideMenu
        activeTab={"Accounting Policies"}
        companyID={companyID}
        companyDataCheck={true}
        setcompanyName={setcompanyName}
      />

      <div className={AcntPolcyCss.subContainer__}>
        {/* <HeaderWhenSecondSideBarActive
                    title="Accounting Policies"
                    secondaryBtnText="Cancel"
                    primaryBtnText="Save"
                /> */}

        <div className={AcntPolcyCss.headerWrapper}>
          <Breadcrumb
            addCls="bgTransprent"
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
          />
          <div>
            <button
              type="button"
              className={`${AcntPolcyCss.createStagingBtn} ${
                createTab === "A" ? AcntPolcyCss.disableCreateBtn : ""
              }`}
              disabled={createTab === "A"}
              onClick={() => {
                if (activeTab === "ECL") {
                  handleClick(
                    `/myfinV2/receivables/create-ecl-scenario/${companyID}`
                  );
                }
              }}
            >
              Create New Scenario
            </button>
          </div>
        </div>

        {/* <Breadcrumb
                    addCls="bgTransprent"
                    items={breadcrumbItems}
                    headerActions={<></>}
                /> */}

        <MulitTabsContainer
          companyID={companyID}
          createOrUpdate={createOrUpdate} // Pass createOrUpdate
          setCreateOrUpdate={setCreateOrUpdate}
          EirScenarioName={EirScenarioName}
          setEirScenarioName={setEirScenarioName}
          EirCalculateType={EirCalculateType}
          setEirCalculateType={setEirCalculateType}
          EirCompute={EirCompute}
          setEirCompute={setEirCompute}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          createTab={createTab}
          setCreateTab={setCreateTab}
          handleClick={handleClick}
        />
      </div>
    </div>
  );
};

export default ReceivablesPolicy;

const MulitTabsContainer = ({
  companyID,
  createOrUpdate, // Receive createOrUpdate from the parent
  setCreateOrUpdate,

  EirScenarioName,
  setEirScenarioName,

  EirCalculateType,
  setEirCalculateType,

  EirCompute,
  setEirCompute,

  activeTab,
  setActiveTab,
  createTab,
  setCreateTab,
  handleClick,
}) => {
  // ECL data List of items
  const [ECLLoansData, setECLLoansData] = useState([]);

  useEffect(() => {
    fetchECLData(companyID, setECLLoansData);
  }, [companyID]);

  // fetch ECL data List
  const fetchECLData = async (companyID, setECLLoansData) => {
    try {
      const response = await getAllReceivableECLScenario(companyID);
      const eclLoans = response.data.receivableECLScenarioList;
      setECLLoansData(eclLoans);
    } catch (err) {
      console.error("Failed to fetch data", err);
    }
  };

  return (
    <div className={AcntPolcyCss.subMainContainer}>
      <div
        className={
          createTab === "A"
            ? AcntPolcyCss.tabContainerSideContainer
            : AcntPolcyCss.tabContainer
        }
      >
        <div className={AcntPolcyCss.tabsContainer}>
          <div
            onClick={() => {
              setActiveTab("ECL");
              setCreateTab("I");
            }}
            className={`${AcntPolcyCss.btn} ${AcntPolcyCss.tab} ${
              activeTab === "ECL" ? AcntPolcyCss.btnActiveFirst : ""
            }`}
          >
            ECL
          </div>
        </div>
        {/* ECL Cards Container */}
        {activeTab === "ECL" && (
          <div className={AcntPolcyCss.tabContantContainer}>
            {/* <div className={AcntPolcyCss.tabHeaderContainer}>
                            <button onClick={() => { 
                                setCreateOrUpdate('C'); 
                                handleClick(`/myfinV2/receivables/create-ecl-scenario/${companyID}`);}} 
                                className={AcntPolcyCss.Btn}>Create New Scenario</button>
                        </div> */}
            <div className={AcntPolcyCss.cardsContainer}>
              <CreateNewScenario
                className={
                  createTab === "A"
                    ? AcntPolcyCss.createNewScenBtnSm
                    : AcntPolcyCss.createNewScenBtn
                }
                onClick={() => {
                  setCreateOrUpdate("C");
                  handleClick(
                    `/myfinV2/receivables/create-ecl-scenario/${companyID}`
                  );
                }}
              />
              {ECLLoansData.map((ecl) => (
                <div
                  key={1}
                  className={
                    createTab === "A"
                      ? AcntPolcyCss.cardContainerSideContainer
                      : AcntPolcyCss.cardContainer
                  }
                  onClick={() => {
                    handleClick(
                      `/myfinV2/receivables/update-ecl-scenario/${companyID}/${ecl._id}`
                    );
                  }}
                >
                  <div className={AcntPolcyCss.cardHeader}>
                    <div className={AcntPolcyCss.CardTitle}>{ecl.name}</div>
                    <div>
                      <CardEditIcon className={AcntPolcyCss.editIconSize} />
                    </div>
                  </div>
                  <div className={AcntPolcyCss.cardDesc}>
                    <img
                      src={demoUserImg}
                      alt=""
                      style={{
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%",
                      }}
                    />
                    &nbsp;
                    <span>
                      Created by
                      <span className={AcntPolcyCss.createdByName}>
                        {ecl.CreatedBy?.username ||
                          ecl.createdBy?.name ||
                          ecl.createdBy?.username ||
                          " Unknown User "}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {createTab === "A" ? <></> : null}
    </div>
  );
};
